import { ref, readonly } from 'vue'
import type { DisplayState } from '@/entries/interact-form/types'

export function useFormState() {
  const isFormSubmitted = ref(false)
  const displayState = ref<DisplayState>('full')

  // フォーム送信済みフラグを設定
  function setFormSubmitted(value: boolean) {
    isFormSubmitted.value = value
  }

  // 表示状態を設定
  function setDisplayState(state: DisplayState) {
    displayState.value = state
  }

  return {
    isFormSubmitted: readonly(isFormSubmitted),
    displayState: readonly(displayState),
    setFormSubmitted,
    setDisplayState,
  }
}
